'use client'

import { Slot, useBridge } from '@/shared/lib'

import * as MobileHeader from './mobile-header'

type Props = {
  label: string
}

export const WebviewHeader = ({ label }: Props) => {
  const { bridge } = useBridge()

  const isNativeApp = bridge?.environment.isNativeApp ?? false

  if (!isNativeApp) {
    return null
  }

  const handleClose = () => {
    if (!bridge) return

    bridge.closeWebviewPopup()
  }

  return (
    <MobileHeader.Root>
      <Slot name="right">
        <MobileHeader.Close onClick={handleClose} label={label} />
      </Slot>
    </MobileHeader.Root>
  )
}
